import React from 'react';
import { theme } from '../../../theme';
export const ChevronLeft = ({ color, size }) => {
    return (React.createElement("svg", { width: theme.fontSizes[size], height: theme.fontSizes[size], viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2071 13.7071C10.8466 14.0676 10.2794 14.0953 9.8871 13.7903L9.79289 13.7071L4.79289 8.70711C4.43241 8.34662 4.40468 7.77939 4.7097 7.3871L4.79289 7.29289L9.79289 2.29289C10.1834 1.90237 10.8166 1.90237 11.2071 2.29289C11.5676 2.65338 11.5953 3.22061 11.2903 3.6129L11.2071 3.70711L6.915 8L11.2071 12.2929C11.5676 12.6534 11.5953 13.2206 11.2903 13.6129L11.2071 13.7071Z", fill: theme.colors[color] })));
};
ChevronLeft.defaultProps = {
    size: 'x2',
    color: 'black',
};
//# sourceMappingURL=index.js.map